import { render, staticRenderFns } from "./PreviousBatchData.vue?vue&type=template&id=1684fa9d"
import script from "./PreviousBatchData.vue?vue&type=script&lang=js"
export * from "./PreviousBatchData.vue?vue&type=script&lang=js"
import style0 from "./PreviousBatchData.vue?vue&type=style&index=0&id=1684fa9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports